export const rsSumAnalysis = [
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "ROADS & SEWERS",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "PRELIMINARIES",
    "": "",
    Amount: "£120,290.14",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "FOUL SEWERS",
    "": "",
    Amount: "£358,839.04",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "STORM SEWERS",
    "": "",
    Amount: "£1,051,230.52",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description:
      "SAVING FOR AS-DUG BACKFILL TO SEWER TRENCHES IN SOFT LANDSCAPED LOCATIONS",
    "": "",
    Amount: "-£5,385.60",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "S38 WORKS TO ACHIEVE 3%+ CBR",
    "": "",
    Amount: "£2,036,775.33",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description:
      "EO FOR 600mm CAPPING LAYER IN 6F2 (CBR 1.5-2%); STOCKPILE SURPLUS",
    "": "£71,982",
    Amount: "If Required",
  },
  {
    Description: "EO REMOVE SURPLUS ARISINGS FROM 600mm CAPPING",
    "": "£30,795",
    Amount: "If Required",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "MAINS SERVICE TRENCHING",
    "": "",
    Amount: "£346,557.02",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description:
      "SUBSOIL / TOPSOIL BALANCE - QUANTS SHOWN, NO ALLOWANCE FOR IMPORT",
    "": "",
    Amount: "Excluded",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "POS PATH",
    "": "",
    Amount: "£36,788.45",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description:
      "COMPOUND & ASSOCIATED HARDSTANDING - PROVISIONAL SUM PENDING FULL SPECS",
    "": "",
    Amount: "£86,659.67",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "PROW DIVERSION",
    "": "",
    Amount: "£47,887.19",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description:
      "ADDITIONAL POS AREAS (REMAINDER OF SITE EXCLUDING TREE REMOVAL AREA) - PROVISIONAL, NO INFO",
    "": "",
    Amount: "£52,748.77",
  },
  {
    Description:
      "TREE REMOVAL POS AREAS - PROVISIONAL, LIMITED LEVELS INFORMAITON",
    "": "",
    Amount: "£141,648.00",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "DISCOUNT",
    "": "",
    Amount: "-£201,587.73",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "ADDITIONAL DISCOUNT FOR CAPPED RETENTION/PHASED RELEASE",
    "": "",
    Amount: "-£30,000.00",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description:
      "EO TO OVERFILL FOOTPATHS WITH STONE AND SACRIFICIAL 50MM BINDER COURSE",
    "": "£228,990.73",
    Amount: "Optional",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "",
    "": "",
    Amount: "",
  },
  {
    Description: "TENDER TOTAL",
    "": "",
    Amount: "£4,042,451",
  },
];
